import React from 'react';
import { BsOctagonFill } from '@react-icons/all-files/bs/BsOctagonFill';

const Hexagon = (props) => {
  return <BsOctagonFill size={19} {...props} />;
};

export default Hexagon;
